const value = Object.freeze({
  Info: 0,
  ViewInventory: 1,
  History: 2,
  RequestTracking: 3,
  ViewAssignedMaterial: 4,
  Reject: 5,
  DeliverToSchool: 6,
  ReceivedByMaster: 7,
  ApprovePurchase: 8,
  ConfirmPurchase: 9,
  PurchaseInfo: 10,
  DeliverToCsee: 11,
  ContinueMaterialRequest: 12,
  Documents: 13,
});
export default value;
